import { breakpoints } from '../../../tokens/js/utils/vars/media';

const header = document.querySelector('.header');
const menuToggle = header?.querySelector('.header__toggle');
const documentBody = document.body;
const noScrollCSSClass = 'no-scroll';
let timer = 0;

const menuToggleHandler = () => {
  let state = '';
  if (header.dataset.menuState !== 'open') {
    state = 'open';
    documentBody.classList.add(noScrollCSSClass);
  } else {
    state = 'closed';
    documentBody.classList.remove(noScrollCSSClass);
  }
  header.dataset.menuState = state;
};

const winResize = () => {
  clearTimeout(timer);

  timer = setTimeout(() => {
    const isDesktopView = window.innerWidth > breakpoints.tablet;

    if (isDesktopView) {
      documentBody.classList.remove(noScrollCSSClass);
    } else if (header.dataset.menuState === 'open') {
      documentBody.classList.add(noScrollCSSClass);
    }
  }, 500);
};

menuToggle?.addEventListener('click', menuToggleHandler);
window.addEventListener('resize', winResize);
